<template>
    <el-tooltip :content="val" :disabled="disabled">
        <!-- $listeners不适用这里 -->
        <el-input ref="ipt" v-model="val" v-bind="$attrs" @focus="$emit('focus')"></el-input>
    </el-tooltip>
</template>

<script>
export default {
    name:'el-tip-input',
    props: {
        // v-model绑定值
        value: {
            default: null
        }
    },
    data() {
        return {
            val: this.value,
            outDisabled:false
        }
    },
    computed:{
        disabled(){
            // 检查下是否被表单禁用，自身禁用，只读
           return !(this.outDisabled || this.$attrs.disabled || this.$attrs.readonly)
        }
    },
    mounted(){
        this.outDisabled =  [...this.$refs.ipt.$el.classList].includes('is-disabled')
    },
    watch: {
        val(data) {
            this.$emit('input', data)
            this.$emit('change', data)
        },
        value(data){
            this.val = data
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/common/tipInput.vue